import styled, { css } from 'styled-components'

import { TransitionPrimary } from '@/lib/mixins'

export const PanelWrapper = styled.div`
  background-color: var(--color-light);
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

export const PanelHeader = styled.div`
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
`

export const PanelTitle = styled.h3`
  font-weight: 600;
  margin-bottom: 0;
`

export const PanelIndicator = styled.span`
  display: inline-flex;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  background-color: var(--color-body);
  margin-left: auto;
  align-items: center;
  justify-content: center;
  ${TransitionPrimary('background')}

  svg {
    fill: var(--color-primary);
    width: 50%;
    height: 50%;
    display: block;
    ${TransitionPrimary('fill, transform')}
  }

  ${props =>
    props.isOpened &&
    css`
      background-color: var(--color-primary);

      svg {
        fill: var(--color-inverted);
        transform: rotate(180deg);
      }
    `};
`

export const PanelContent = styled.div`
  border-top: 2px solid var(--color-body);
  padding: 1.5rem;

  dl {
    padding: 0;
    margin: 0 0 0.5rem 0;
    display: flex;

    dt {
      flex: 0 0 30%;
      text-align: right;
      margin-right: 1rem;
      color: var(--color-muted);
      opacity: 1;
    }

    dd {
      flex: 1 1 auto;
      font-weight: 500;
    }
  }

  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
`
